import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { adminLogin, setAdminToken, getAdminToken } from "../lib/api";

const AdminLogin = () => {
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (getAdminToken()) return <Navigate to="/admin/orders" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { token } = await adminLogin(password);
            setAdminToken(token);
            toast.success("Signed in");
            navigate("/admin/orders");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            data-testid="page-admin-login"
            className="min-h-[calc(100vh-200px)] flex items-center justify-center px-6 py-16"
        >
            <div className="w-full max-w-md bg-white border border-[#E5E0D8] rounded-sm p-10">
                <div className="w-12 h-12 bg-[#0A2342] flex items-center justify-center mb-6">
                    <Lock className="text-[#FBF9F6]" size={18} strokeWidth={1.5} />
                </div>
                <p className="text-[11px] tracking-[0.35em] uppercase text-[#9E5A35] mb-3">
                    Admin
                </p>
                <h1 className="font-serif-display text-3xl md:text-4xl text-[#0A2342] mb-8 leading-[1.05]">
                    Sign in to manage orders.
                </h1>
                <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
                    <div>
                        <label className="text-[11px] tracking-[0.22em] uppercase text-[#5C6A79]">
                            Password
                        </label>
                        <input
                            data-testid="admin-password-input"
                            type="password"
                            required
                            autoFocus
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full bg-transparent border border-[#E5E0D8] px-4 py-3 text-sm focus:outline-none focus:border-[#0A2342]"
                        />
                    </div>
                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={loading}
                        className="btn-primary w-full justify-center disabled:opacity-40"
                    >
                        {loading ? (
                            <>
                                <Loader2 className="animate-spin" size={16} />
                                Signing in…
                            </>
                        ) : (
                            "Sign In"
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
